import styled, { css } from 'styled-components';

const BOTTOM_BAR_HEIGHT = '100';
const BOTTOM_BAR_CONTENT_WIDTH = '1500';

const BottomBarContainer = styled.div`
  ${({ theme: { elevation, media, palette, spacing, zIndex } }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: ${palette.baseColors.wairua};
    z-index: ${zIndex.sticky};
    box-shadow: ${elevation.topShadow};

    & > div {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      padding: ${spacing.s2} ${spacing.s3};
      max-width: ${BOTTOM_BAR_CONTENT_WIDTH}px;

      ${media.up('slim')} {
        height: ${BOTTOM_BAR_HEIGHT}px;
        padding: 0 ${spacing.s4};
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      ${media.up('big')} {
        padding: 0 120px;
      }
    }
  `}
`;

export default BottomBarContainer;
